import { Component } from '@angular/core';

@Component({
  selector: 'app-painelcontrato',
  templateUrl: './painelcontrato.component.html',
  styleUrl: './painelcontrato.component.css'
})
export class PainelcontratoComponent {

}
